// extracted by mini-css-extract-plugin
module.exports = {"social-links":"_9cadcb71c3--social-links--SiuFG","input-link":"_9cadcb71c3--input-link--VLtQZ","vk":"_9cadcb71c3--vk--YL3bQ","ok":"_9cadcb71c3--ok--DH029"};